/**
 * F 472 — THE CREATE EVENT.
 *
 * The global "+" lives in the Workspace header; the actions it triggers live
 * in the sidebar. This module holds the ONE name they agree on, so neither
 * side has to import the other.
 *
 * One event, one handler set: the global "+" and each section's "+" reach the
 * same three actions through this, so the two entrances cannot drift.
 */

/** The three things the sidebar can create. */
export type SidebarCreateKind = 'page' | 'database' | 'task';

/** The event name. Emitted with `{ kind: SidebarCreateKind }`. */
export const SIDEBAR_CREATE_EVENT = 'fc:sidebar:create';
